import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms'; // 1. Import FormsModule

import { AssessmentsService } from '../../service/entity-services/assessments.service';
import { EmailService } from '../../service/communications/email.service';

import { Assessment, QuestionAndAnswerObject } from '../../objects/assessments';
import { Contract } from '../../objects/contract';

import { EntityType } from '../../objects/interface-library';
import { environment } from '../../../environments/environment';
import { Entity } from '../../objects/entity';

import { TitleCasePipe } from '@angular/common';


import { MatFormFieldModule } from '@angular/material/form-field'; 
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { AttachmentConnectionsComponent } from '../../entity-form-components/attachment-connections/attachment-connections.component';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-new-risk-assessment',
    templateUrl: './new-risk-assessment.component.html',
    styleUrls: ['./new-risk-assessment.component.css'],
    standalone: true,
    imports: [
      FormsModule,
      MatFormFieldModule,
      MatGridListModule,
      MatDividerModule,
      MatExpansionModule,
      MatDatepickerModule,
      MatProgressSpinnerModule,
      MatCardModule,
      AutoCompleteModule,
      TitleCasePipe,
      AttachmentConnectionsComponent
    ]
  })
export class NewRiskAssessmentComponent extends Entity implements OnInit {

  public currentContract: Partial<Contract>;

  printView = false;

  contractObject = null;
  currentParty = null;

  attachmentObjectArray = [];

  partyFriendlyName = null;

  ownerFriendlyName = null;
  assessorFriendlyName = null;
  finalReviewerFriendlyName = null;

  linkToContractFile = null;

  statusUnchanged = true;

  assessmentObject: Assessment;

  listOfUsers: any;

  waiting = false;

  readOnly = false;
  typeReadOnly = true;

  attestation = null;
  requiredActions = null;
  assessmentTypes = null;
  assessmentStatuses = null;
  questions = null;
  scores?: any | null = null;
  assessmentInstructions = null;

  averageScore = 0;
  totalScore = 0;

  assessmentAllStatusTypes = null;
  assessmentRequiredActions = null;
  assessmentQuestionsOne = null;
  assessmentQuestionsTwo = null;
  assessmentAssignedToAssessorEmailText = null;
  assessmentAssignedToAssessorEmailBottom = null;

  questionGroup = -1;
  errorUploading: boolean = false;
  fileName: any;
  binaryFile: any;

  constructor(
              
              
              private dialogRef: MatDialogRef<NewRiskAssessmentComponent>,
              private assessmentService: AssessmentsService,
              public emailService: EmailService,
              @Inject(MAT_DIALOG_DATA) data) {

    super();

    this.assessmentObject = {};

    this.currentContract = {};

    dialogRef.disableClose = true;

    this.assessmentObject.entityId = data.entityId;
    this.assessmentObject.entityType = data.entityType;
    this.assessmentObject.partyNum = data.partyNum;

    if (data.assessmentObject) {
      this.assessmentObject = data.assessmentObject;
    }

    if (data.assessmentData) {
      this.assessmentObject = data.assessmentData;
    }

    if (data.readOnly) {
      this.readOnly = data.readOnly;
    }

    if (data.contractId) {
      this.assessmentObject.contractId = data.contractId;
    }
    
  }


  async ngOnInit() {

    // if (this.globalDataService.allUsers.length === 0) {
    //   this.listOfUsers = await this.globalDataService.getAllUsersPromise();
    // } else {
    //   this.listOfUsers = this.globalDataService.allUsers;
    // }

    // if (!this.assessmentObject.assessmentNum) {
    //   // This means we are making a NEW assessment
    //   this.assessmentObject.assessmentNum = (new Date).getTime().toString();
    //   this.typeReadOnly = false;
    // }


    // if (this.assessmentObject.entityType == EntityType.Contract &&
    //     this.assessmentObject.entityId) {

    //       this.contractObject = await this.contractManagerService.getContractById(this.assessmentObject.entityId);

    //       this.assessmentObject.sourceRecord = this.contractObject.nameOfContract;

    //       if (this.contractObject.contractFileName) {
    //         this.linkToContractFile = environment.s3Location + this.contractObject.contractFileName;
    //       }

    //       if (this.contractObject && this.contractObject.attachments && this.contractObject.attachments.length > 0) {
    //         this.attachmentObjectArray = await this.globalDataService.getAttachmentObjectArray(this.contractObject.attachments);
    //       }

    //       await this.addSitesFriendlyNameToEntity(this.contractObject);
    // }


    // if (this.assessmentObject.entityType == EntityType.Party &&
    //     this.assessmentObject.entityId) {

    //       // BUGBUG:  need to fix this function call to only return data
    //     this.currentParty = await this.contractManagerService.getPartyByNum(this.assessmentObject.entityId);
    //     this.currentParty = this.currentParty.vendorData;

    //     this.assessmentObject.sourceRecord = this.currentParty.name;

    //     if (this.currentParty && this.currentParty.attachments && this.currentParty.attachments.length > 0) {
    //       this.attachmentObjectArray = await this.globalDataService.getAttachmentObjectArray(this.currentParty.attachments);
    //     }
    // }

    // try {
    //   // BUGBUG:  this should be a new API called getObjectByNum(type, number)
    //   let foundAssessment = this.globalDataService.allAssessments.find( assessment => assessment.assessmentNum === this.assessmentObject.assessmentNum);

    //   if (foundAssessment) {
    //     this.assessmentObject = foundAssessment.assessmentData;
    //   } 

    // } catch (error) {
    //   console.warn('new-risk-assessment | init | failed adding full assessment data');
    // }


    // // await this.assessmentService.getAssessmentQuestionsMatrix();
    // await this.getEntityData();
    // await this.getGoogleSheetsStaticData();
    // // this.calculateScore();

    console.log('*** ASSESSMENT OBJECT *** ', this.assessmentObject);

  }


  // This is for the ngIf on the average score calculation.  Only way I 
  // could find to address the NaN problem.  
  isNumber(value) {
    return Number.isNaN(value);
  }






  async printAssessment() {

    // this.getEntityData();

    // this.printView = true;

    // let openWindow = window.open("","","width=900, height=600, left=200, top=100");

    // let body = document.getElementById('print-section').innerHTML;

    // openWindow.document.write(`
    //     <html>
    //         <head>
    //             <title>Print Page</title>
    //         </head>
    //         <body>${body}</body>
    //     </html>`
    // );

    // openWindow.print();
    // openWindow.close();

    // await this.globalDataService.delay(1500);

    // this.printView = false;
  }



  sliderThumbValue(value: number) {

    let returnValue = value - 1;
    let returnValueAsString = returnValue.toString();

    if (returnValue < 0) {
      returnValueAsString = 'N/A';
    }

    return returnValueAsString;

  }


  // BUGBUG:  this should be in one of the parent objects
  async getUserObject(email) {

    // if (this.globalDataService.allUsers.length === 0) {
    //   this.listOfUsers = await this.globalDataService.getAllUsersPromise();
    // } else {
    //   this.listOfUsers = this.globalDataService.allUsers;
    // }

    let foundUser = this.listOfUsers.find( user => user.email === email);

    if (foundUser) {
      return foundUser;
    } else {

      console.warn('new-risk-assessment | getUserObject | did NOT find user: ', email);
      console.log('all users: ', this.listOfUsers);
      

      return null;
    }

  }




  async assessmentStatusSelectionChanged() {

    this.statusUnchanged = false;

  }



  async assessmentTypeSelectionChanged() {

    // let foundAssessmentType = this.assessmentTypes.findIndex((type) => {return type == this.assessmentObject.type});

    // this.questionGroup = foundAssessmentType;

    // this.averageScore = 0;
    // this.totalScore = 0;

    // // console.log('*** assessment types: ', this.assessmentTypes);
    // // console.log('*** group: ', this.questionGroup);

    // let questionColumn = 'E';

    // switch (this.questionGroup) {
    //   case 0:
        
    //     break;

    //   case 1:

    //     questionColumn = 'J';
        
    //     break;        

    //   case 2:

    //     questionColumn = 'K';
        
    //     break;

    //   case 3:

    //     questionColumn = 'N';
        
    //     break;

    //   default:
    //     break;
    // }

    // try {
    //   this.questions = await this.assessmentService.getAssessmentQuestionsByColumn(questionColumn);
    //   this.initializeQuestionsAndAnswersIntoAssessment();
    // } catch (error) {
    //   console.error('new-risk-assessment | assessmentTypeSelectionChanged | failed to get questions: ', error);
    // }
  }


  onScoreChange(selectedIndex: number, questionIndex: number): void {

    // Set the score to the selected index
    // this.assessmentObject.questionsAndAnswers[questionIndex].score = selectedIndex;
    // this.assessmentObject.questionsAndAnswers[questionIndex].scoreDescription = this.scores[selectedIndex];

    // this.totalScore = this.assessmentService.calculateTotalScore(this.assessmentObject);
    // this.assessmentObject.totalScore = this.totalScore;
  }


  async getGoogleSheetsStaticData() {

    // this.attestation = await this.assessmentService.getAttestation();
    // this.requiredActions = await this.assessmentService.getRequiredActions();
    // this.assessmentTypes = await this.assessmentService.getAssessmentTypes();
    // this.assessmentStatuses = await this.assessmentService.getAssessmentStatuses();
    // this.scores = await this.assessmentService.getAssessmentScores();

    // if (!this.assessmentObject.questionsAndAnswers) {
    //   this.initializeQuestionsAndAnswersIntoAssessment();
    // } 

    // this.assessmentInstructions = await this.assessmentService.getAssessmentInstructions();
  }





  async initializeQuestionsAndAnswersIntoAssessment() {

    this.assessmentObject.questionsAndAnswers = [];

    // try {

    //   // this.questions = await this.assessmentService.getAssessmentQuestions();

    //   this.questions.forEach(question => {
  
    //     // let foundQuestion = this.assessmentObject.questionsAndAnswers.filter( qa => qa.question === question);
  
    //     // if (foundQuestion.length === 0) {
  
    //       let addThisQuestion = new QuestionAndAnswerObject;
  
    //       addThisQuestion.question = question;
    
    //       this.assessmentObject.questionsAndAnswers.push(addThisQuestion);
    
    //     // }
  
    //   });


    // } catch (error) {
    //   console.warn(' new-risk-assessment | initializeQuestionsAndAnswersIntoAssessment | failed getting questions');
    // }

  }





  cancelDialog() {
    this.dialogRef.close(null);
  }



  async sendFinalReviewerEmailNotification() {

      console.log('*** inside sendFinalReviewerEmailNotification: ', this.assessmentObject.finalReviewer);

      // if (!this.currentContract) {
      //   this.currentContract = await this.contractService.getContractFullyHydrated(this.assessmentObject.parentEntityNumber);
      // }

      // let linkToContract = 'Not available at this time.';

      // if (this.currentContract) {
      //   linkToContract = this.currentContract.linkToContract;
      // }  

      // let htmlBody = 'Assessment called: ' + this.assessmentObject.name + ' is saved with you as the reviewer.<br><br>' +
      //                 // 'The required action is ' + this.assessmentObject.requiredAction + '<br><br>' +
      //                 'The assessors are: ' + this.assessmentObject.assessorList + '<br><br>' +
      //                 'The owner is: ' + this.assessmentObject.owner;
      //                 '<br><br>' +
      //                 '<b>Link To Contract:</b> ' + linkToContract + '?opentab=assessment' +
      //                 '<br><br>';
              
      // // console.log('htmlBody: ', htmlBody);

      // // Only try to send it if there is a final reviewer.
      // if (this.assessmentObject.finalReviewer) {

      //   await this.emailService
      //             .sendEmail(this.assessmentObject.finalReviewer,
      //                         'You have been assigned as a Final Reviewer on an Assessment',
      //                         htmlBody);
      // }

  }



  async sendOwnerEmailNotification() {

    console.log('inside sendFinalReviewerEmailNotification: ', this.assessmentObject.finalReviewer);

    // if (!this.currentContract) {
    //   this.currentContract = await this.contractService.getContractFullyHydrated(this.assessmentObject.parentEntityNumber);
    // }

    // let linkToContract = 'Not available at this time.';

    // if (this.currentContract) {
    //   linkToContract = this.currentContract.linkToContract;
    // }  

    // let htmlBody = 'Assessment called: ' + this.assessmentObject.name + ' is saved with you as the owner.<br><br>' +
    //                 // 'The required action is ' + this.assessmentObject.requiredAction + '<br><br>' +
    //                 'The assessors are: ' + this.assessmentObject.assessorList + '<br><br>' +
    //                 'The final reviewer is: ' + this.assessmentObject.finalReviewer;
    //                 '<br><br>' +
    //                 '<b>Link To Contract:</b> ' + linkToContract + '?opentab=assessment' +
    //                 '<br><br>';
            
    // // console.log('htmlBody: ', htmlBody);

    // // Only try to send it if there is a final reviewer.
    // if (this.assessmentObject.owner) {

    //   await this.emailService
    //             .sendEmail(this.assessmentObject.owner,
    //                         'You have been assigned as an Owner on an Assessment',
    //                         htmlBody);
    // }

}



  async sendAssessorEmail() {

      // let emailObject = await firstValueFrom(this.assessmentService.getAssessorEmail());

      // // console.log('*** SEND ASSESSOR EMAIL: ', emailObject);

      // let contractDetailsForEmail = 
      //   '<b>Contract Name:</b> ' + this.assessmentObject.name +
      //   // '<br><br>' +
      //   // '<b>Contract Party:</b> ' + this.assessmentObject.part +
      //   // '<br><br>' +
      //   // '<b>Due Date:</b> ' + criticalDateAsObject.format('MM/DD/YYYY') +
      //   // '<br><br>' +
      //   // '<b>Link To Contract:</b> ' + linkToContract + '?opentab=assessment' +
      //   '<br><br>';

      // let emailBody = emailObject.topPart +
      //                 contractDetailsForEmail +
      //                 emailObject.bottomPart;

      // await this.emailService
      //           .sendEmail( this.assessmentObject.assessor,
      //                       this.assessmentObject.name,
      //                       emailBody);

  }


  async sendInRemediationEmail() {

    // const reviewRequiredEmail = await this.googleSheetsService.getAssessmentReadyForFinalReviewEmail();
    // const reviewRequiredEmailPartTwo = await this.googleSheetsService.getAssessmentReadyForFinalReviewEmailPartTwo();
  
    let contractDetailsForEmail = 
      '<b>Contract Name:</b> ' + this.assessmentObject.name +
      // '<br><br>' +
      // '<b>Contract Party:</b> ' + this.assessmentObject.part +
      // '<br><br>' +
      // '<b>Due Date:</b> ' + criticalDateAsObject.format('MM/DD/YYYY') +
      // '<br><br>' +
      // '<b>Link To Contract:</b> ' + linkToContract + '?opentab=assessment' +
      '<br><br>';

    // let emailBody = reviewRequiredEmail +
    //                 contractDetailsForEmail +
    //                 reviewRequiredEmailPartTwo;

    console.log('EMAIL - IN REMEDIATION - SEND TO FINAL REVIEWER: ', this.assessmentObject.finalReviewer);

    // await this.emailService
    //           .sendEmail( this.assessmentObject.finalReviewer,
    //                       this.assessmentObject.name,
    //                       emailBody);

}
  


async sendActionPlanCompletedEmail() {

  // const reviewCompletedEmail = await this.googleSheetsService.getAssessmentFinalReviewCompletedEmail();
  // const reviewCompletedEmailPartTwo = await this.googleSheetsService.getAssessmentFinalReviewCompletedEmailPartTwo();


  // let contractDetailsForEmail = 
  //   '<b>Contract Name:</b> ' + this.assessmentObject.name +
  //   // '<br><br>' +
  //   // '<b>Contract Party:</b> ' + this.assessmentObject.part +
  //   // '<br><br>' +
  //   // '<b>Due Date:</b> ' + criticalDateAsObject.format('MM/DD/YYYY') +
  //   // '<br><br>' +
  //   // '<b>Link To Contract:</b> ' + linkToContract + '?opentab=assessment' +
  //   '<br><br>';

  // let emailBody = reviewCompletedEmail +
  //                 contractDetailsForEmail +
  //                 reviewCompletedEmailPartTwo;

  // console.log('EMAIL - ACTOIN PLAN COMPLETED - SEND TO FINAL REVIEWER: ', this.assessmentObject.finalReviewer);

  // await this.emailService
  //           .sendEmail( this.assessmentObject.finalReviewer,
  //                       this.assessmentObject.name,
  //                       emailBody);

}







  async saveAndSend() {

    this.waiting = true;

    this.assessmentService.assessmentSavedEmailTriggers(this.assessmentObject, this.currentContract, this.currentParty);

    this.onSubmit();

  }




  async onSubmit() {
   
    console.log('*** about to save Assessment internal object: ', this.assessmentObject);

    await this.assessmentService.writeAssessment(this.assessmentObject);

    // BUGBUG:  Only do this if you confirm the assessment isn't already there. assessmentNum
    // this.globalDataService.allAssessments.push(this.assessmentObject);

    this.waiting = false;

    this.dialogRef.close(this.assessmentObject);

  }


}
